import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const Icon = (props) => (
  <Box component="span" mr="2px">
    {props.children}
  </Box>
);

Icon.propTypes = {
  children: PropTypes.shape({}).isRequired,
};

export default Icon;
